import React, { useState } from 'react';
import { MdClose } from 'react-icons/md';

const MentorSettingsModal = ({ onClose, currentSettings, onSave }) => {
  const [aiMode, setAiMode] = useState(currentSettings.aiMode || 'cloud');
  const [localUrl, setLocalUrl] = useState(currentSettings.localUrl || 'http://localhost:11434');
  const [localModel, setLocalModel] = useState(currentSettings.localModel || 'llama3');

  const handleSave = () => {
    onSave({ aiMode, localUrl, localModel });
    onClose();
  };

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalContent mentorSettingsModal" onClick={(e) => e.stopPropagation()}>
        <div className="modalHeader" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}>AI Mentor Settings</h3>
          <button className="btn iconBtn closeBtn" onClick={onClose} style={{ background: 'transparent', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer' }}>
            <MdClose size={20} />
          </button>
        </div>
        
        <div className="settingsBody" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div className="formGroup">
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: 'var(--text-primary)' }}>AI Backend Mode</label>
            <div className="radioGroup" style={{ display: 'flex', gap: '16px', background: 'rgba(0,0,0,0.2)', padding: '12px', borderRadius: '8px', border: '1px solid var(--border-color)' }}>
              <label className="radioLabel" style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                <input 
                  type="radio" 
                  name="aiMode" 
                  value="cloud" 
                  checked={aiMode === 'cloud'} 
                  onChange={(e) => setAiMode(e.target.value)}
                />
                <span style={{ fontSize: '13.5px' }}>Cloud API (Default)</span>
              </label>
              <label className="radioLabel" style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                <input 
                  type="radio" 
                  name="aiMode" 
                  value="local" 
                  checked={aiMode === 'local'} 
                  onChange={(e) => setAiMode(e.target.value)}
                />
                <span style={{ fontSize: '13.5px' }}>Local Ollama</span>
              </label>
            </div>
            <p className="settingHint" style={{ marginTop: '8px', fontSize: '12px', color: 'var(--text-secondary)' }}>
              Cloud API routes requests through the hosted backend. Local Ollama makes direct browser requests to your machine.
            </p>
          </div>

          {aiMode === 'local' && (
            <div className="localOllamaConfig" style={{ display: 'flex', flexDirection: 'column', gap: '16px', background: 'rgba(255,255,255,0.02)', padding: '16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.05)' }}>
              <div className="infoAlert" style={{ padding: '12px', background: 'rgba(218, 54, 51, 0.1)', border: '1px solid rgba(218, 54, 51, 0.3)', borderRadius: '6px', fontSize: '13px', lineHeight: 1.5, color: 'rgba(255,255,255,0.9)' }}>
                <strong style={{ color: 'var(--danger)' }}>Important:</strong> To allow the browser to connect to your local Ollama, you must start it with CORS enabled:
                <br />
                <code style={{ display: 'block', marginTop: '8px', background: 'rgba(0,0,0,0.3)', padding: '6px 10px', borderRadius: '4px', fontFamily: 'monospace' }}>OLLAMA_ORIGINS="*" ollama serve</code>
              </div>
              
              <div className="formGroup">
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', color: 'var(--text-secondary)' }}>Ollama API URL</label>
                <input 
                  type="text" 
                  className="inputBox" 
                  style={{ width: '100%', padding: '10px', background: 'rgba(0,0,0,0.2)', border: '1px solid var(--border-color)', borderRadius: '6px', color: '#fff', fontSize: '14px' }}
                  value={localUrl} 
                  onChange={(e) => setLocalUrl(e.target.value)} 
                  placeholder="http://localhost:11434"
                />
              </div>

              <div className="formGroup">
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', color: 'var(--text-secondary)' }}>Model Name</label>
                <input 
                  type="text" 
                  className="inputBox" 
                  style={{ width: '100%', padding: '10px', background: 'rgba(0,0,0,0.2)', border: '1px solid var(--border-color)', borderRadius: '6px', color: '#fff', fontSize: '14px' }}
                  value={localModel} 
                  onChange={(e) => setLocalModel(e.target.value)} 
                  placeholder="llama3, mistral, etc..."
                />
              </div>
            </div>
          )}
        </div>

        <div className="modalActions" style={{ marginTop: '24px', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
          <button className="btn cancelBtn" onClick={onClose} style={{ padding: '8px 16px', background: 'transparent', border: '1px solid var(--border-color)', color: '#fff', borderRadius: '6px', cursor: 'pointer' }}>Cancel</button>
          <button className="btn saveBtn" onClick={handleSave} style={{ padding: '8px 16px', background: 'var(--primary)', border: 'none', color: '#fff', borderRadius: '6px', cursor: 'pointer', fontWeight: 500 }}>Save Settings</button>
        </div>
      </div>
    </div>
  );
};

export default MentorSettingsModal;
